import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '@cc-shopping/platform-analytics/AnalyticsSkuViewed/Context';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { type BoxProps, ButtonBase, Typography } from '@mui/material';
import { useCompareContext } from '../../../Context';
import { useCreditCardCompareOfferContext } from '../../OfferContext';
import { RemoveCardButtonContainer } from './RemoveCardButton.container';
type RemoveCardButtonProps = {
  additionalContainerProps?: BoxProps;
};
export function RemoveCardButton(t0) {
  const $ = _c(12);
  const {
    additionalContainerProps
  } = t0;
  const {
    removeIdToCompare
  } = useCompareContext();
  const {
    offer: t1
  } = useCreditCardCompareOfferContext();
  const {
    id
  } = t1;
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t2;
  if ($[0] !== skuImpressionId) {
    t2 = {
      actionName: "cc_compare_select_card",
      actionSection: "cc_compare_category",
      actionType: "remove",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[0] = skuImpressionId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const removeCardAction = usePageAction(t2);
  let t3;
  if ($[2] !== id || $[3] !== removeCardAction || $[4] !== removeIdToCompare) {
    t3 = () => {
      removeIdToCompare(id);
      removeCardAction();
    };
    $[2] = id;
    $[3] = removeCardAction;
    $[4] = removeIdToCompare;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleRemoval = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Typography sx={{
      color: "blues.main",
      textDecoration: "underline"
    }}>Remove Card</Typography>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== handleRemoval) {
    t5 = <ButtonBase onClick={handleRemoval} disableRipple={true}>{t4}</ButtonBase>;
    $[7] = handleRemoval;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== additionalContainerProps || $[10] !== t5) {
    t6 = <RemoveCardButtonContainer additionalProps={additionalContainerProps}>{t5}</RemoveCardButtonContainer>;
    $[9] = additionalContainerProps;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}